<template>
  <div class="content_con">
    <p class="text-center">
      <span class="title">东进公司东莞市外林业防制服务项目</span>
    </p>
    <p class="text-center subtitle-container">
      <span class="title">采购失败公告</span>
    </p>
    <p class="text-indent-37 line-height-37 item">
      <span class="text"
        ><span
          >本公司（广东东进有害生物防控技术有限公司）于2025年6月17日就东进公司东莞市外林业防制服务项目进行询价采购。现就本次采购的结果公告如下：</span
        ></span
      >
    </p>
    <p class="line-height-40 section-title">
      <span class="text"
        >一、采购项目名称：<span class="underline">东进公司东莞市外林业防制服务项目</span> </span
      >
    </p>
    <p class="line-height-40 section-title">
      <span class="text">二、废标公告发布时间：2025年6月17日</span>
    </p>
    <p class="line-height-40 section-title">
      <span class="text">三、开标（报价）时间：2025年6月17日下午14时30分整</span>
    </p>
    <p class="line-height-40 section-title">
      <span class="text">四、废弃（终止）事项、内容及原因：</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span class="text">因本项目有效投标单位不足三家，本次采购失败。</span>
    </p>
    <p class="line-height-40 section-title">
      <span class="text">五、废弃（终止）时间：2025年6月17日</span>
    </p>
    <p class="line-height-40 section-title">
      <span class="section-title-text">六、联系事项</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span>单位名称：广东东进有害生物防控技术有限公司</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span class="text">联系人：张雪婷</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span class="text">联系电话：</span>
      <span class="number">0769-22008298</span>
    </p>
    <p class="text-indent-37 line-height-40 item">
      <span class="text">邮箱地址：</span>
      <span class="number">3403006320@qq.com</span>
    </p>
    <p class="signature">
      <span class="content">发布人：广东东进有害生物防控技术有限公司</span>
    </p>
    <p class="signature">
      <span class="content">发布时间：</span>
      <span class="number">2025</span>
      <span class="content">年</span>
      <span class="number">6</span>
      <span class="content">月</span>
      <span class="number">18</span>
      <span class="content">日</span>
    </p>
    <p style="height: 20px"></p>
    <p style="line-height: 16px">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
        title=""
        ><img
          style="vertical-align: middle; margin-right: 2px"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif" /></a
      ><a
        style="font-size: 12px; color: #0066cc"
        href="/20250627/东进公司东莞市外林业防制服务项目采购失败公告.pdf"
        title="东进公司东莞市外林业防制服务项目采购失败公告.pdf"
        >东进公司东莞市外林业防制服务项目采购失败公告.pdf</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "DocDisplay",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.content_con {
  font-size: 14px;
  font-family: "宋体", Arial;
  padding: 0px 50px;
  color: #515050;

  a {
    text-decoration: none;
  }

  .text-center {
    text-align: center;
  }

  .subtitle-container {
    margin-bottom: 21px;
  }

  .line-height-2em {
    line-height: 2em;
  }

  .text-indent-37 {
    text-indent: 37px;
  }

  .line-height-37 {
    line-height: 37px;
  }

  .section-title {
    font-size: 19px;
    font-family: 黑体;
  }

  .item {
    font-size: 19px;
    font-family: 仿宋_GB2312;
  }

  .number {
    font-family: "Times New Roman", "serif";
  }

  .underline {
    text-decoration: underline;
  }

  .title {
    font-size: 27px;
    font-family: 方正小标宋简体;
  }

  .subtitle {
    font-size: 27px;
    font-family: 方正小标宋简体;
  }

  .text-autospace {
    margin: 3px;
    padding: 3px;

    span {
      color: #515050;
      font-size: 14px !important;
    }
  }

  .icon {
    margin-left: 5px;
    vertical-align: middle;
  }

  .file-link {
    text-align: left;
    font-size: 12px;
    color: #0066cc;
  }

  .line-height-40 {
    line-height: 40px;
  }

  .date {
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: "Times New Roman", "serif";
    font-weight: normal;
  }

  .result {
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: 仿宋_GB2312;
    font-weight: 200;
    font-size: 19px;

    .fa {
      font-size: 19px;
      font-family: "Times New Roman", "serif";
      font-weight: normal;
    }
  }

  .duration {
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: 仿宋_GB2312;
    font-weight: normal;
  }

  .signature {
    font-size: 19px;
    line-height: 39px;
    font-family: 仿宋_GB2312;
    text-align: right;
  }
}
</style>
